const isNumber = (value: number | null): boolean => typeof value === 'number';

const isBoolean = (value: boolean | null): boolean => typeof value === 'boolean';

export { isNumber, isBoolean };
